import React from 'react';

import {AttributeDescriptionGenerationController} from 'src/modules/ai';
import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';

import {Group, Item} from '@pb/kit-component-group';
import Loading, {Types as LoadingTypes} from '@pb/kit-component-loading';

type Props = {
    attributeName?: string,
    attributeType?: string,
    eventChangeRequest?: EventChangeRequest,
    busy: boolean,
    onDescriptionGenerate: (suggest: string) => void,
};

export const DescriptionAutosuggestActionBar = (props: Props) => {
    const {
        attributeName,
        attributeType,
        eventChangeRequest,
        busy,
        onDescriptionGenerate,
    } = props;

    return (
        <Group>
            <Item>{busy ? <Loading type={LoadingTypes.ICON} fast={true}/> : null}</Item>
            <AttributeDescriptionGenerationController
                attributeName={attributeName}
                attributeType={attributeType}
                eventChangeRequest={eventChangeRequest}
                onDescriptionGenerate={onDescriptionGenerate}
            />
        </Group>
    );
};
